<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';
import router from '@/routes/router';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/plantas`;
const token = utilsService.getToken();

const plantaService = {
  async get(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      response.data.empresaID = response.data.empresaID == 0 ? null : response.data.empresaID;
      response.data.regionID = response.data.regionID == 0 ? null : response.data.regionID;
      response.data.ciudadID = response.data.ciudadID == 0 ? null : response.data.ciudadID;
      response.data.paisID = response.data.paisID == 0 ? null : response.data.paisID;
      return response.data;
    } catch (error) {
      router.push('/error');
    }
  },

  async getAll() {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async create(formRaw) {
    try {
      const form = { ...formRaw };
      const response = await axios.post(`${apiUrl}/create`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al crear la planta.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async update(formRaw, id) {
    try {
      const form = { ...formRaw };
      form.empresaID = form.empresaID || 0;

      const response = await axios.put(`${apiUrl}/${id}`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  },

  async deleteBy(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async updatePasillos(formRaw, id, empresa) {
    try {
      const form = Object.values(formRaw).map(pasillo => {
        const { ingresosOrigen, ingresosDestino, ...rest } = pasillo;
        return rest;
      });
      const response = await axios.put(`${apiUrl}/${id}/${empresa}/pasillos`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  },
};

export default plantaService;
</script>
